export default __webpack_public_path__ + "static/media/app-pic-5.8820813c.png";